export default "__VITE_ASSET__2XlYRR4l__"